import { Config } from "../config/config.js";
import { Helper } from "./helper.js";
import { Dialog, DialogAction, DialogProps } from "../components/dialog.js";
import React from "react";
import ReactDOM from "react-dom";
export class DialogHelper {
    public static alert(text: string, header: string = null) {
        DialogHelper.confirm(text, null, null, null, false);
    }



    public static ask(options: AskDialogOptions): Promise<boolean> {
        return new Promise<boolean>((resolve) => {

            const targetElement = $("<div>");
            $("body").append(targetElement);

            const remove_dialog = () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            }
            const actions: DialogAction[] = [];
            if (options.canCancel) {
                actions.push({
                    label: Config.translations.cancel,
                    action: () => {
                        resolve(false)
                    },
                    primary: false
                })
            }
            actions.push({
                label: Config.translations.ok,
                action: () => {
                    resolve(true)
                },
                primary: true
            })

            const dialogProps: DialogProps = {
                title: options.header,
                open: true,
                actions: actions,
                width: options.width ?? 500,
                afterClose: remove_dialog
            };
            ReactDOM.render(
                <Dialog {...dialogProps}>
                    {options.isHtml ? <div dangerouslySetInnerHTML={{ __html: options.text }} /> : <label>{options.text}</label>}
                </Dialog >, targetElement[0]);


        });
    }

    public static confirm(text: string, width: number = null, firstButtonText: string = null, secondButtonText: string = null, canCancel: boolean = true): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            createDialog({
                width: width,
                isPrompt: false,
                onCancel: _ => resolve(false),
                onOk: _ => resolve(true),
                text,
                firstButtonText: firstButtonText,
                secondButtonText: secondButtonText,
                isPassword: false,
                canCancel: canCancel
            });
        });
    }

    public static prompt(text: string, defaultValue?: string, width: number = null, isPassword: boolean = false, canCancel: boolean = true): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            createDialog({
                isPassword: isPassword,
                width: width,
                isPrompt: true,
                defaultValue: defaultValue || "",
                onCancel: _ => resolve(null),
                onOk: v => resolve(v),
                text,
                canCancel
            });
        });
    }

    public static promptNumber(text: string, defaultValue?: number, format: string = null, decimals: number = null, spinners: boolean = null, min: number = null, max: number = null, width: number = null, canCancel: boolean = true): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            createDialog({
                isPassword: false,
                width: width,
                isPrompt: true,
                defaultValue: defaultValue || 0,
                format: format,
                decimals: decimals,
                spinners: spinners,
                min: min,
                max: max,
                onCancel: _ => resolve(null),
                onOk: v => resolve(v),
                text,
                canCancel
            });
        });
    }

    public static choose(text: string, labels: { label: string, value: any, primary?: boolean }[], cancel: boolean = false, width: number = null): Promise<any> {
        let lst: ChooseDialogAction[] = [];
        if (cancel)
            lst.push({ label: Config.translations.cancel, value: null, primary: false });
        labels.forEach((item) => {
            lst.push({ label: item.label, value: item.value, primary: Helper.getValueOrDefault(item.primary, false) })
        })
        return new Promise<string>((resolve, reject) => {
            createChooseDialog({
                width: Helper.getValueOrDefault(width, lst.length * 160),
                click: v => resolve(v),
                text: text,
                cancel: cancel,
                actions: lst
            });
        });
    }
}


interface ConfirmConfig extends DialogConfig {
    isPrompt: false;
}

interface PromptConfig extends DialogConfig {
    isPrompt: true;
    onOk: (value: string) => void;
    defaultValue: string | number;
    width: number;
    format?: string;
    min?: number;
    max?: number;
    spinners?: boolean;
    decimals?: number;
}

interface DialogConfig {
    text: string;
    onOk: Function;
    onCancel: Function;
    width: number;
    firstButtonText?: string;
    secondButtonText?: string;
    isPassword: boolean;
    canCancel: boolean
}

interface ChooseDialogConfig {
    width: number;
    cancel: boolean;
    text: string;
    click: Function;
    actions: ChooseDialogAction[];
}

interface ChooseDialogAction {
    label: string;
    value: any;
    primary: boolean;
}

const createDialog = (config: ConfirmConfig | PromptConfig) => {
    const elem = document.createElement("div");
    document.body.appendChild(elem);
    let input: HTMLInputElement = null;

    if (config.isPrompt === true) {
        const isNumeric = typeof (config.defaultValue) == "number";

        const div = document.createElement("div");
        div.style.marginBottom = "5px";
        elem.appendChild(div);

        const wrapper = document.createElement("span");
        wrapper.classList.add("k-input");
        wrapper.classList.add(isNumeric ? "k-numerictextbox" : "k-textbox");
        wrapper.classList.add("k-input-solid");
        wrapper.classList.add("k-input-md");
        wrapper.classList.add("k-rounded-md");


        input = document.createElement("input");
        if (isNumeric) {
            input.type = "number";
            input.value = config.defaultValue.toString();
            if (config.min)
                input.setAttribute("min", config.min.toString());
            if (config.max)
                input.setAttribute("max", config.max.toString());
            if (config.format)
                input.setAttribute("format", config.format);
            if (config.spinners)
                input.setAttribute("spinners", config.spinners.toString());
            if (config.decimals)
                input.setAttribute("decimals", config.decimals.toString());
        }
        else
            input.value = config.defaultValue.toString();

        input.classList.add("k-input-inner");
        input.style.width = "100%";

        if (config.isPassword) {
            input.type = "password";
        }

        wrapper.appendChild(input);


        elem.appendChild(wrapper);
    }

    const firstButtonText = Helper.hasValue(config.firstButtonText) ? config.firstButtonText : Config.translations.cancel;
    const secondButtonText = Helper.hasValue(config.secondButtonText) ? config.secondButtonText : Config.translations.ok;
    const onKeyUp = (e: JQuery.KeyUpEvent) => {
        const escape = 27;
        const enter = 13;
        switch (e.keyCode) {
            case enter:
                if (config.isPrompt === true) {
                    config.onOk(input.value);
                } else {
                    config.onOk();
                }
                dialog.close();
                break;
            case escape:
                //weil javascript -.-
                if (config.canCancel) {
                    dialog.close()
                }
                break;
        }
    };
    const actions = [];
    if (config.canCancel) {
        actions.push({
            action: _ => {
                config.onCancel();
            },
            text: firstButtonText
        })
    }

    actions.push({
        action: _ => {
            if (config.isPrompt === true) {
                config.onOk(input.value);
            } else {
                config.onOk();
            }
        },
        primary: true,
        text: secondButtonText
    });

    $(document).bind("keyup", onKeyUp);
    const dialog = $(elem).kendoDialog({
        actions: actions,
        close: _ => {
            $(document).unbind("keyup", onKeyUp);
            dialog.destroy();
        },
        closable: false,
        minWidth: 200,
        width: (config.width != null) ? config.width + "px" : "",
        maxWidth: screen.width,
        visible: false
    }).data("kendoDialog");
    let textElement = dialog.element.prev().find(".k-window-title");
    textElement.html(config.text);
    textElement.css("min-height", "25px");
    dialog.open();
    let el = $(".k-dialog input");
    if (el.length > 0)
        el[0].focus()
}
const createChooseDialog = (config: ChooseDialogConfig) => {
    const elem = document.createElement("div");
    document.body.appendChild(elem);
    const dialog = $(elem).kendoDialog({
        actions: config.actions.map((item: ChooseDialogAction, index: number) => {
            let action = {
                action: _ => {
                    config.click(item.value);
                },
                text: item.label,
                primary: item.primary
            }
            return action;
        }),
        close: _ => {
            dialog.destroy();
        },
        closable: false,
        minWidth: 200,
        width: (config.width != null) ? config.width + "px" : "",
        maxWidth: screen.width,
        visible: false
    }).data("kendoDialog");

    dialog.element.prev().find(".k-window-title").html(config.text);
    dialog.open();
}

interface AskDialogOptions {
    text: string;
    header: string;
    width?: number;
    isHtml?: boolean;
    canCancel?: boolean;
}